import React from 'react';
import { useAuth } from '../../context/AuthContext';

const AuthTest = () => {
  const { isAuthenticated, user, loading } = useAuth();

  return (
    <div style={{ padding: '20px' }}>
      <h2>Authentication Status Test</h2>
      
      <div style={{ margin: '20px 0' }}>
        <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
        <p><strong>Is Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}</p>
        <p><strong>User:</strong> {user ? JSON.stringify(user, null, 2) : 'No user'}</p>
      </div>
      
      <div style={{ margin: '20px 0' }}>
        <h3>Local Storage:</h3>
        <p><strong>isAuthenticated:</strong> {localStorage.getItem('isAuthenticated')}</p>
        <p><strong>user:</strong> {localStorage.getItem('user')}</p>
        <p><strong>token:</strong> {localStorage.getItem('token') ? 'Present' : 'Not present'}</p>
      </div>
      
      <div style={{ margin: '20px 0' }}>
        <h3>Actions:</h3>
        <button 
          onClick={() => {
            localStorage.setItem('isAuthenticated', 'true');
            localStorage.setItem('user', JSON.stringify({
              id: 1,
              email: 'test@example.com',
              firstName: 'Test',
              lastName: 'User'
            }));
            window.location.reload();
          }}
          style={{ padding: '10px 20px', marginRight: '10px' }}
        >
          Set Test Auth
        </button>
        
        <button 
          onClick={() => {
            localStorage.removeItem('isAuthenticated');
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.reload();
          }}
          style={{ padding: '10px 20px' }}
        >
          Clear Auth
        </button>
      </div>
    </div>
  );
};

export default AuthTest;
